import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getClientList, getLocations } from 'store/clientSlice';
import { getVendorBillDetailsV2 } from 'store/vendorBillSliceV2';
import { getUIVersion } from 'utils/router-static-data';
import { Box } from 'atoms';
import VendorBillRegenrationForm from 'components/forms/vendor-bill-generation/VendorBillRegenration.form';
import { search_type } from 'utils';

export default function VendorBillEditing() {
	const { id } = useParams();
	const [vendorId, setVendorId] = useState('');
	const [vendorBillRes, setVendorBillRes] = useState({});
	const { cities = [], statesWithCites } = useSelector((state) => state.clientState);
	const uiVersion = getUIVersion();
	const useV2API = uiVersion === 'new';
	console.log('statesWithCites', statesWithCites);

	const dispatch = useDispatch();
	useEffect(() => {
		if (id) {
			const action = useV2API
				? getVendorBillDetailsV2({ id })
				: getClientList({
						search_type: 'vendor_bill_details',
						filter_by: {
							id,
							is_editable: true,
						},
				  });
			dispatch(action).then((res) => {
				setVendorBillRes(res?.data?.vendor_bill);
				setVendorId(res?.data?.vendor_bill?.vendor_id);

				if (res) {
					setVendorBillRes(res.data);
				} else {
					setVendorBillRes([]);
				}
			});
		}
		dispatch(
			getLocations({
				search_type: search_type?.location,
				filter_by: {},
			})
		);
	}, [dispatch, id, useV2API]);

	return (
		<Box>
			<VendorBillRegenrationForm
				vendorId={vendorId}
				cities={cities}
				vendorBillRes={vendorBillRes}
			/>
		</Box>
	);
}
